'use client';

import { c as _c } from "react/compiler-runtime";
import { WebAPIAmendmentsPage } from '@/globals/webApiTypes/pages/WebAPIAmendmentsPage';
import { useSelectedFilters } from '@/sections/filter/useSelectedFilters';
import { filterAmendmentResults } from './filterAmendmentResults';
import { AmendmentsResults } from './AmendmentsResults';
export const FilteredAmendments = t0 => {
  const $ = _c(7);
  const {
    results,
    filters,
    promos
  } = t0;
  const [selectedFilters] = useSelectedFilters();
  let t1;
  if ($[0] !== filters || $[1] !== results || $[2] !== selectedFilters) {
    t1 = filterAmendmentResults(results, selectedFilters, filters);
    $[0] = filters;
    $[1] = results;
    $[2] = selectedFilters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const filteredResults = t1;
  let t2;
  if ($[4] !== filteredResults || $[5] !== promos) {
    t2 = <AmendmentsResults results={filteredResults} promos={promos} />;
    $[4] = filteredResults;
    $[5] = promos;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};